import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function NoHtmlAndCurlyBracesValidator(): ValidatorFn {
  const htmlRegex = /<\/?[a-z][\s\S]*>/i; // Matches basic HTML tags
  const curlyBracesRegex = /[{}]/; // Matches Curly Braces
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value && (htmlRegex.test(value) || curlyBracesRegex.test(value))) {
      return { noHtmlOrCurlyBraces: true };
    }
    return null;
  };
}
